import { render } from "./ProfileWindow.vue?vue&type=template&id=db7bd45e"
import script from "./ProfileWindow.vue?vue&type=script&lang=js"
export * from "./ProfileWindow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__